import { render, staticRenderFns } from "./menuRightManage.vue?vue&type=template&id=7dc062b5&scoped=true&"
import script from "./menuRightManage.vue?vue&type=script&lang=js&"
export * from "./menuRightManage.vue?vue&type=script&lang=js&"
import style0 from "./menuRightManage.vue?vue&type=style&index=0&id=7dc062b5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc062b5",
  null
  
)

export default component.exports